import type { Vendor } from '@stash/shared-types';
import { useAdminVendorsStore } from './context';

/** The full vendor catalog held in the admin store. */
export const useAdminVendors = (): Vendor[] => useAdminVendorsStore((s) => s.vendors);

/** True while the catalog is being fetched. */
export const useAdminVendorsLoading = (): boolean => useAdminVendorsStore((s) => s.loading);

/** Load error message, if the last fetch failed. */
export const useAdminVendorsError = (): string | undefined =>
  useAdminVendorsStore((s) => s.error);

/** True once the catalog has loaded successfully (session cache). */
export const useAdminVendorsLoaded = (): boolean => useAdminVendorsStore((s) => s.isLoaded);

/** Idempotent loader — call on mount. */
export const useLoadAllVendors = (): (() => Promise<void>) =>
  useAdminVendorsStore((s) => s.loadAll);

/** Force a re-fetch (retry / refresh). */
export const useReloadVendors = (): (() => Promise<void>) =>
  useAdminVendorsStore((s) => s.reload);
